const menuToggle = document.querySelector("[data-menu-toggle]");
const navigation = document.querySelector("[data-navigation]");
const header = document.querySelector("[data-header]");
const languageSwitcher = document.querySelector("[data-language-switcher]");

if (languageSwitcher) {
  document.addEventListener("click", (event) => {
    if (languageSwitcher.open && !languageSwitcher.contains(event.target)) {
      languageSwitcher.open = false;
    }
  });

  languageSwitcher.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && languageSwitcher.open) {
      languageSwitcher.open = false;
      languageSwitcher.querySelector("summary").focus();
    }
  });
}

if (menuToggle && navigation) {
  const setMenuState = (isOpen) => {
    menuToggle.setAttribute("aria-expanded", String(isOpen));
    menuToggle.setAttribute(
      "aria-label",
      isOpen ? menuToggle.dataset.labelClose : menuToggle.dataset.labelOpen,
    );
    navigation.classList.toggle("is-open", isOpen);
    document.body.classList.toggle("menu-open", isOpen);
  };

  menuToggle.addEventListener("click", () => {
    const isOpen = menuToggle.getAttribute("aria-expanded") === "true";
    setMenuState(!isOpen);
  });

  navigation.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => setMenuState(false));
  });

  document.addEventListener("click", (event) => {
    if (
      !navigation.contains(event.target) &&
      !menuToggle.contains(event.target)
    ) {
      setMenuState(false);
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      setMenuState(false);
      menuToggle.focus();
    }
  });

  window
    .matchMedia("(min-width: 901px)")
    .addEventListener("change", (event) => {
      if (event.matches) setMenuState(false);
    });
}

if (header) {
  const updateHeader = () =>
    header.classList.toggle("is-scrolled", window.scrollY > 16);

  updateHeader();
  window.addEventListener("scroll", updateHeader, { passive: true });
}

const counters = document.querySelectorAll("[data-counter]");
const prefersReducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)",
).matches;

if (!prefersReducedMotion && "animate" in Element.prototype) {
  document.querySelectorAll(".faq__list > details").forEach((details) => {
    const summary = details.querySelector(":scope > summary");
    let animation = null;
    let targetOpen = details.open;

    if (!summary) return;

    const cancelAnimation = () => {
      if (!animation) return;

      animation.onfinish = null;
      animation.cancel();
      animation = null;
    };

    const finishAnimation = (isOpen) => {
      details.open = isOpen;
      details.style.height = "";
      details.style.overflow = "";
      animation = null;
    };

    const animateDetails = (isOpen) => {
      targetOpen = isOpen;
      const startHeight = `${details.getBoundingClientRect().height}px`;
      cancelAnimation();
      details.style.height = "";
      details.open = true;

      const endHeight = isOpen
        ? `${details.offsetHeight}px`
        : `${summary.offsetHeight}px`;

      details.style.height = startHeight;
      details.style.overflow = "hidden";
      animation = details.animate(
        { height: [startHeight, endHeight] },
        {
          duration: 280,
          easing: "cubic-bezier(0.4, 0, 0.2, 1)",
        },
      );
      animation.onfinish = () => finishAnimation(isOpen);
    };

    summary.addEventListener("click", (event) => {
      event.preventDefault();
      animateDetails(animation ? !targetOpen : !details.open);
    });
  });
}

const setCounterValue = (counter, value) => {
  counter.textContent = new Intl.NumberFormat(
    document.documentElement.lang === "en" ? "en-GB" : "tr-TR",
  ).format(value);
};

const animateCounter = (counter) => {
  const target = Number.parseInt(counter.dataset.counter, 10);
  if (!Number.isFinite(target)) return;

  if (prefersReducedMotion) {
    setCounterValue(counter, target);
    return;
  }

  const duration = 1100;
  const startedAt = performance.now();

  const update = (timestamp) => {
    const progress = Math.min((timestamp - startedAt) / duration, 1);
    const easedProgress = 1 - (1 - progress) ** 3;
    setCounterValue(counter, Math.round(target * easedProgress));

    if (progress < 1) requestAnimationFrame(update);
  };

  requestAnimationFrame(update);
};

if ("IntersectionObserver" in window) {
  const counterObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        animateCounter(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.45 },
  );

  counters.forEach((counter) => counterObserver.observe(counter));
} else {
  counters.forEach(animateCounter);
}

const revealItems = document.querySelectorAll("[data-reveal]");

if (
  revealItems.length &&
  !prefersReducedMotion &&
  "IntersectionObserver" in window
) {
  const revealObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.addEventListener(
          "transitionend",
          () => entry.target.classList.add("reveal-complete"),
          {
            once: true,
          },
        );
        entry.target.classList.add("is-revealed");
        observer.unobserve(entry.target);
      });
    },
    {
      rootMargin: "0px 0px -8% 0px",
      threshold: 0.12,
    },
  );

  revealItems.forEach((item) => revealObserver.observe(item));
}

const floatingContact = document.querySelector(".floating-contact");
const footer = document.querySelector(".footer");

if (floatingContact && footer && "IntersectionObserver" in window) {
  const footerObserver = new IntersectionObserver(
    ([entry]) =>
      floatingContact.classList.toggle("is-raised", entry.isIntersecting),
    { threshold: 0.05 },
  );

  footerObserver.observe(footer);
}
